import {DELEGATES_STORE_NAME} from '../reducers/reducers'

export function getDelegates(state) {
    const { items, errorMessage } = state[DELEGATES_STORE_NAME] || { }
    return { delegates: items || null, errorMessage }
}
